import Swal from 'sweetalert2';

export class AuthManager {
  static async handleTokenExpiration(messageData) {
    const token = window.localStorage.getItem('accessToken');
    
    if (messageData?.token && messageData.token === token) {
      await Swal.fire({
        title: 'Token expirado',
        text: 'O token de acesso expirou!',
        icon: 'error',
      });
      window.location.assign('/auth/login');
      return true;
    }
    return false;
  }
}